module.exports = __webpack_public_path__ + "media/2x/graph-37@2x-b91e9b83.png";